import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'preferred-provider-details',
  templateUrl: './preferred-provider-details.component.html',
  styleUrls: ['./preferred-provider-details.component.scss']
})
export class PreferredProviderDetailsComponent implements OnInit {
  serviceList: any;
  loading: boolean;
  subServiceList: any;
  service: number;
  subService: number;
  providerKey: number;
  locationKey: number;
  providerList: any;
  locationList: any;
  customerKey: any;
  preferredProviderDetails: any;
  editFlag: number;
  currentPspKey: any;
  sortPriority: any;
  editService: any;
  editSubService: any;
  editRefusal: any;
  constructor(public dialogRef: MatDialogRef<PreferredProviderDetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.customerKey = sessionStorage.getItem('legacyCustomerKeyId');
    this.getServiceList();
    this.getPrefrredProvidersDetails();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getServiceList() {
    this.loading = true;
    this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorServiceSearch`)
      .subscribe((response: any) => {
        this.serviceList = response.body;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_getServiceList', error);
      });
  }

  getSubServices(serviceKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorSubServiceSearch/${serviceKey}`)
      .subscribe((response: any) => {
        this.subServiceList = response.body;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_getSubServices', error);
      }, () => {

      });
  }

  getProviders(subServiceKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `getPreferredProviders/${subServiceKey}`)
      .subscribe((response: any) => {
        this.providerList = response.response;
        console.log(this.providerList);
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_getProviders', error);
      }, () => {
      });
  }

  getPhysicalAddress(providerKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `getProviderPhysicalAddress/${providerKey}`)
      .subscribe((response: any) => {
        this.locationList = response.response;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_getPhysicalAddress', error);
      }, () => {

      });
  }

  addPrefrredProvider() {
    this.loading = true;
    let data = {
      "customerKey": this.customerKey,
      "service": this.service,
      "subService": this.subService,
      "providerKey": this.providerKey,
      "locationKey": this.locationKey,
      "pspKey": 0
    }
    this.http.post(environment.baseUrl + `addPrefrredProvider`, data)
      .subscribe((response: any) => {
        console.log(response);
        this.getPrefrredProvidersDetails();
        this.service = 0;
        this.subService = 0;
        this.providerKey = 0;
        this.locationKey = 0;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_addPrefrredProvider', error);
      }, () => {

      });
  }

  getPrefrredProvidersDetails() {
    this.loading = true;
    this.http.get(environment.baseUrl + `getPrefrredProvidersDetails/${this.customerKey}`)
      .subscribe((response: any) => {
        this.preferredProviderDetails = response.response;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_getPrefrredProvidersDetails', error);
      }, () => {

      });
  }

  deletePreferredProvider(pspKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `deletePreferredProvider/${pspKey}`)
      .subscribe((response: any) => {
        this.getPrefrredProvidersDetails();
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_deletePreferredProvider', error);
      }, () => {

      });
  }

  editPreferredProvider(providerDetails) {
    this.editService = providerDetails.service;
    this.getSubServices(this.editService);
    this.editSubService = providerDetails.subService;
    this.currentPspKey = providerDetails.pspKey;
    this.sortPriority = providerDetails.sortPriority;
    this.editRefusal = providerDetails.refusal;
    this.editFlag = 1;
  }

  savePreferredProvider() {
    this.loading = true;
    let data = {
      "pspKey": this.currentPspKey,
      "service": this.editService,
      "subService": this.editSubService,
      "sortPriority": this.sortPriority,
      "refusal": this.editRefusal == 'YES' ? 1 : 0
    }

    this.http.post(environment.baseUrl + `addPrefrredProvider`, data)
      .subscribe((response: any) => {
        this.getPrefrredProvidersDetails();
        this.currentPspKey = 0;
        this.editFlag = 0;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('PreferredProviderDetailsComponent_savePreferredProvider', error);
      }, () => {

      });

  }

  cancel() {
    this.currentPspKey = 0;
    this.editFlag = 0;
  }
}
